import axios from "axios";
import { clearAndLogout } from "./helpers";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_LOCAL_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearAndLogout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;